module.exports = __webpack_public_path__ + "img/people_star.b6ac9c70.svg";